module.exports = __webpack_public_path__ + "img/joy_cat.b4f65daa.png";